export default "__VITE_ASSET__a1e88a4c__"